<!--
  使用率兑付率弹窗
-->
<template>
  <div class="map-tooltips">
    <div class="header">{{ infoObj.areaName }}</div>
    <div class="body">
      <div class="item">
        <p class="item-left">受益户数</p>
        <p class="item-right">{{ infoObj.numBeneficiaries }} <span>户</span></p>
      </div>
      <div class="item">
        <p class="item-left">机具台数</p>
        <p class="item-right">
          {{ infoObj.numMachines || 0 }} <span>台</span>
        </p>
      </div>
      <div class="item">
        <p class="item-left">中央补贴</p>
        <p class="item-right">
          {{ infoObj.centralSubsidy || 0 }} <span>万元</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "map-tooltips",
  props: {
    infoObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.map-tooltips {
  width: vw(256);
  height: vh(148);
  padding: vh(8) vw(16);
  background: url("../../../../assets/images/governmentAffairs/purchaseAllowance/map/alert-bg.png") no-repeat;
  background-size: 100% 100%;
  opacity: 1;
  font-family: Microsoft YaHei;
  font-style: italic;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  .header {
    font-size: fontSize(18);
    text-shadow: 1px 2px 0px #845100;
  }
  .body {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    .item {
      display: flex;
      align-items: baseline;
      margin-bottom: vh(-1);
      .item-left {
        font-size: fontSize(14);
        margin-right: vw(9);
      }
      .item-right {
        font-family: Rajdhani-Bold;
        font-weight: 600;
        font-size: fontSize(30);
        color: #fffdc8;
        span {
          font-size: fontSize(14);
        }
      }
    }
  }
}
</style>
